// Simple in-memory cache for school stats
class SchoolStatsCache {
    constructor() {
        this.cache = new Map();
        this.cacheTimeout = 15 * 60 * 1000; // 15 minutes - longer cache to reduce API calls
    }

    get(schoolId) {
        const cached = this.cache.get(schoolId);
        if (!cached) return null;

        // Check if cache is expired
        if (Date.now() - cached.timestamp > this.cacheTimeout) {
            this.cache.delete(schoolId);
            return null;
        }

        return cached.data;
    }

    set(schoolId, data) {
        this.cache.set(schoolId, {
            data,
            timestamp: Date.now()
        });
    }

    clear() {
        this.cache.clear();
    }

    // Clear specific school's cache
    clearSchool(schoolId) {
        this.cache.delete(schoolId);
    }

    // Clear expired entries
    cleanup() {
        const now = Date.now();
        for (const [key, value] of this.cache.entries()) {
            if (now - value.timestamp > this.cacheTimeout) {
                this.cache.delete(key);
            }
        }
    }
}

// Create a singleton instance
const schoolStatsCache = new SchoolStatsCache();

// Cleanup expired entries every 10 minutes
setInterval(() => {
    schoolStatsCache.cleanup();
}, 10 * 60 * 1000);

export default schoolStatsCache;
